import { openSubcontractorDrawer } from '../../../State/subcontractorDrawer'

export default (name) => (dispatch, getState) => {

  const { controls: { periodIndex } } = getState().screens.Planner

  dispatch(openSubcontractorDrawer({ periodIndex, search: name }))

}
